import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataTableComponent } from "./datatable.component";
import { TableBodyComponent } from "./tablebody/tablebody.component";
import { SharedModule } from "primeng/primeng";
import { ColumnHeadersComponent } from "./columnheader/columnheader.component";

@NgModule({
  imports: [CommonModule, SharedModule, FormsModule],
  exports: [DataTableComponent, SharedModule],
  declarations: [DataTableComponent, TableBodyComponent, ColumnHeadersComponent]
})
export class DataTableModule {}
